"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PubSub_1 = __importDefault(require("./PubSub"));
/**
 * Event object used by page to do internal logic.
 * Used with the method pageSubscribe and pageUnSubscribe
 * of the PubSub for automatic clean up of pages events
 *
 * @param {String} eventName Name of the event to listen to
 * @param {Function} callback Function to fire
 * @constructor
 */
function default_1(eventName, callback) {
    let id = null;
    return {
        subscribe(scope) {
            id = PubSub_1.default.subscribe(eventName, callback, scope);
        },
        unsubscribe() {
            PubSub_1.default.unsubscribe(id);
            id = null;
        },
    };
}
exports.default = default_1;
